import { t } from 'i18next';
import { createElement } from 'react';
import { TSubRegionResource } from '../../../../shared/types/utilityTypes';
import { CLASS_DATA } from '../../../../shared/utils';
import { namedRoutes, resolveRoutePath } from '../../bundles/routes';
import { ClassIcon } from '../../../../../../shared/frontend/scripts/wow/components/ClassIcon';
import { EMenuEntry, TMenuEntry } from './menuHelper';
import { isCurrentExpansionRaid, isNextExpansionRaid } from '../../../../shared/enumHelpers';

/* tslint:disable:max-line-length */

// const GUIDES_MENU_ITEMS: TMenuEntry[] = [
//   {
//     type: EMenuEntry.ITEM,
//     title: 'nav:learn.how-to-prepare-for-a-new-raid',
//     link: 'https://raider.io/news/504-raiding-101-how-to-prep-for-a-new-raid',
//     wowIcon: 'achievement_boss_illidan'
//   },
//   {
//     type: EMenuEntry.ITEM,
//     title: 'nav:learn.establishing-guild-goals',
//     link: 'https://raider.io/news/531-raiding-101-setting-guild-goals-as-raid-leadership',
//     wowIcon: 'ability_marksmanship'
//   },
//   {
//     type: EMenuEntry.ITEM,
//     title: 'nav:learn.guild-recruitment',
//     link: 'https://raider.io/news/540-raiding-101-guild-recruitment',
//     wowIcon: 'inv_misc_groupneedmore'
//   }
// ];

function undefinedIfEmptyArray(arr: any[]) {
  return arr.length === 0 ? undefined : arr;
}

function getExtrasMenus(props: any) {
  const menus: TMenuEntry[] = [
    {
      type: EMenuEntry.ITEM,
      title: 'nav:community.update-character-or-guild',
      link: 'update_now',
      iconClassName: 'fas fa-arrow-up-to-arc'
    },
    {
      type: EMenuEntry.ITEM,
      title: 'nav:community.shop',
      link: 'https://shop.raider.io',
      iconClassName: 'fa fa-shirt'
    },
    {
      type: EMenuEntry.DIVIDER
    },
    {
      type: EMenuEntry.ITEM,
      title: 'nav:community.faq',
      link: 'https://support.raider.io',
      iconClassName: 'fa fa-info-circle'
    }
  ];
  return menus;
}

function getRealmsMenuItems(props: any) {
  const sortedSubRegions: TSubRegionResource[] = props.subRegions.sort((a: any, b: any) => {
    if (a.name < b.name) {
      return -1;
    } else if (a.name > b.name) {
      return 1;
    }
    return 0;
  });

  const REALMS_MENU_ITEMS: TMenuEntry[] = [
    {
      type: EMenuEntry.ITEM,
      title: 'nav:all-realms',
      link: resolveRoutePath(namedRoutes.ConnectedRealms, {})
    },
    {
      type: EMenuEntry.DIVIDER
    },
    ...['us', 'eu', 'kr', 'tw']
      .map((regionSlug) => ({
        name: `regions:${regionSlug}.name`,
        slug: regionSlug
      }))
      .map<TMenuEntry>((regionInfo) => ({
        type: EMenuEntry.ITEM,
        title: regionInfo.name,
        link: resolveRoutePath(namedRoutes.ConnectedRealms, { region: regionInfo.slug }),
        children: undefinedIfEmptyArray(
          sortedSubRegions
            .filter((sr) => sr.regions.length === 1 && sr.regions.find((r) => r.slug === regionInfo.slug))
            .map<TMenuEntry>((sr) => ({
              type: EMenuEntry.ITEM,
              title: sr.name,
              link: resolveRoutePath(namedRoutes.ConnectedRealms, { region: sr.slug })
            }))
        )
      })),
    {
      type: EMenuEntry.DIVIDER
    },
    ...sortedSubRegions
      .filter((sr) => sr.regions.length > 1)
      .map<TMenuEntry>((sr) => ({
        type: EMenuEntry.ITEM,
        title: sr.name,
        link: resolveRoutePath(namedRoutes.ConnectedRealms, { region: sr.slug })
      }))
  ];

  return REALMS_MENU_ITEMS;
}

// Can't have this be a React component because rc-menu passes in special props to child menus
// function getRaidSubMenuItems(props: any) {
//   const { raid } = props;
//   const menuItems: TMenuEntry[] = [
//     {
//       type: EMenuEntry.ITEM,
//       title: `raids:${raid.slug}.name`,
//       customIcon: asset(`/images/${raid.slug}/icon.jpg`),
//       link: `/${raid.slug}/rankings/world/mythic`,
//       children: [
//         {
//           type: EMenuEntry.ITEM,
//           title: 'nav:raids.raid-rankings',
//           link: resolveRoutePath(
//             namedRoutes.RaidRankings,
//             buildRouteParams(props.match.params, {
//               raid: raid.slug,
//               region: props.region,
//               difficulty: props.difficulty
//             })
//           )
//         },
//         {
//           type: EMenuEntry.ITEM,
//           title: 'nav:raids.boss-rankings',
//           children: raid.encounters.map((boss: any) => ({
//             type: EMenuEntry.ITEM,
//             title: `raids:${raid.slug}.bosses.${boss.slug}.name`,
//             customIcon: asset(boss.iconUrl),
//             link: resolveRoutePath(
//               namedRoutes.BossRankings,
//               buildRouteParams(props.match.params, {
//                 raid: raid.slug,
//                 boss: boss.slug,
//                 region: props.region,
//                 difficulty: props.difficulty
//               })
//             )
//           }))
//         },
//         {
//           type: EMenuEntry.ITEM,
//           title: 'nav:raids.hall-of-fame',
//           link: resolveRoutePath(
//             namedRoutes.RaidHallOfFame,
//             buildRouteParams(props.match.params, {
//               raid: raid.slug,
//               region: props.region,
//               difficulty: props.difficulty
//             })
//           )
//         },
//         ...(raidSupportsWorldFirstTracker(raid.slug)
//           ? ([
//               {
//                 type: EMenuEntry.ITEM,
//                 title: 'nav:raids.regional-race-tracker',
//                 link: resolveRoutePath(
//                   namedRoutes.RaidWorldFirstTracker,
//                   buildRouteParams(props.match.params, {
//                     raid: raid.slug,
//                     region: props.region,
//                     difficulty: props.difficulty
//                   })
//                 )
//               }
//             ] as any) // TODO: type fix - should be TMenuEntry[]
//           : []),
//         {
//           type: EMenuEntry.DIVIDER
//         },
//         ...(raidSupportsGlobalCoverage(raid.slug)
//           ? ([
//               {
//                 type: EMenuEntry.ITEM,
//                 title: 'nav:raids.rwf-global-coverage',
//                 link: resolveRoutePath(
//                   namedRoutes.RaidGlobalCoverage,
//                   buildRouteParams(props.match.params, {
//                     raid: RAID_METADATA_BY_SLUG[raid.slug]?.globalCoverageSlug || raid.slug
//                   })
//                 )
//               }
//             ] as any) // TODO: type fix - should be TMenuEntry[]
//           : [])
//       ]
//     }
//   ];
//   return menuItems;
// }

export function getMenuItems(props: any) {
  let foundRaid = null;
  const relevantRaids: any[] = [];
  const otherRaids: any[] = [];
  for (const raid of props.raids) {
    if (isCurrentExpansionRaid(raid.slug) || isNextExpansionRaid(raid.slug)) {
      relevantRaids.push(raid);
    } else {
      otherRaids.push(raid);
    }
    if (!foundRaid && raid.slug === props.match.params.raid) {
      foundRaid = raid;
    }
  }

  // const primaryRaid = _.first(relevantRaids);
  // const currentRaid = foundRaid || primaryRaid;

  // let RAID_MENU: TMenuEntry[] = [
  //   {
  //     type: EMenuEntry.ITEM,
  //     title: 'nav:main.raids',
  //     titleClass: 'text-bold'
  //   }
  // ];
  // if (currentRaid) {
  //   RAID_MENU = [
  //     {
  //       type: EMenuEntry.ITEM,
  //       title: 'nav:main.raids',
  //       titleClass: 'text-bold',
  //       // isDropdown: true,
  //       link: resolveRoutePath(namedRoutes.RaidRankings, {
  //         raid: currentRaid.slug,
  //         region: 'world',
  //         difficulty: 'mythic'
  //       }),
  //       children: () => [
  //         ..._.flatMap(relevantRaids, (raid: any) =>
  //           getRaidSubMenuItems({ match: props.match, raid, region: 'world', difficulty: 'mythic' })
  //         ),
  //         {
  //           type: EMenuEntry.DIVIDER
  //         },
  //         {
  //           type: EMenuEntry.ITEM,
  //           title: 'nav:raids.older-raids',
  //           wowIcon: 'wow_token02',
  //           children: () =>
  //             _.flatMap(otherRaids, (raid: any) =>
  //               getRaidSubMenuItems({ match: props.match, raid, region: 'world', difficulty: 'mythic' })
  //             )
  //         }
  //       ]
  //     }
  //   ];
  // }

  // const { ownProfiles: recruitmentProfiles } = useRecruitmentProfiles();
  // const { resetPagination, specs } = props;

  // const { [RecruitmentActivationStatus.Active]: activeProfiles = [] } = _.groupBy(recruitmentProfiles, 'status');

  // const buildProfileLink = (p: any, category: string) => {
  //   let specIcon = {};
  //   if (p.entity_type === RecruitmentEntityType.Character) {
  //     const main = _.find(p.characters, { ordinal: 0 })!;
  //     const mainSpec = getCharacterProfileMainSpec(p, specs);

  //     specIcon = createElement(SpecIcon, { class: main?.character?.class?.slug, spec: mainSpec?.slug });
  //   }

  //   return {
  //     type: EMenuEntry.ITEM,
  //     title: getRecruitmentProfileName(p),
  //     link:
  //       category === 'active'
  //         ? buildSearchUrlFromProfile(p)
  //         : resolveRoutePath(namedRoutes.RecruitmentProfileConfig, { profile_id: p.id }),
  //     onClick: resetPagination,
  //     className: getProfileEntityColorClassname(p),

  //     wowIcon: ACTIVITY_INFO_FOR_TYPE[p.activity_type].icon,
  //     ...(p.entity_type === RecruitmentEntityType.Character
  //       ? {
  //           customIconComponent: specIcon
  //         }
  //       : {
  //           customIcon: asset(`/images/site/${getProfileFaction(p)}_logo_xs.png`)
  //         })
  //   };
  // };

  // const hasRecruitmentProfiles = !_.isEmpty(recruitmentProfiles);
  // const hasActiveRecruitmentProfiles = !_.isEmpty(activeProfiles);
  // const isLoggedIn = props.currentFeatures.authenticated;

  // const RECRUITMENT_MENU = props.currentFeatures.recruitment_view
  //   ? [
  //       {
  //         type: EMenuEntry.ITEM,
  //         title: 'nav:main.recruitment',
  //         titleClass: 'text-bold',
  //         link: isLoggedIn
  //           ? resolveRoutePath(namedRoutes.UserRecruitmentProfiles)
  //           : resolveRoutePath(namedRoutes.Recruitment),
  //         // isBeta: true,
  //         children: isLoggedIn
  //           ? () => [
  //               ...(!hasRecruitmentProfiles
  //                 ? [
  //                     {
  //                       type: EMenuEntry.ITEM,
  //                       title: 'nav:recruitment.create-profile',
  //                       link: resolveRoutePath(namedRoutes.RecruitmentProfileCreate)
  //                     }
  //                   ]
  //                 : []),
  //               ...(hasRecruitmentProfiles
  //                 ? [
  //                     {
  //                       type: EMenuEntry.ITEM,
  //                       title: 'nav:recruitment.view-profiles',
  //                       link: resolveRoutePath(namedRoutes.UserRecruitmentProfiles)
  //                     }
  //                   ]
  //                 : []),
  //               ...(hasActiveRecruitmentProfiles
  //                 ? [{ type: EMenuEntry.DIVIDER }, ..._.map(activeProfiles, (p) => buildProfileLink(p, 'active'))]
  //                 : []),
  //               { type: EMenuEntry.DIVIDER },
  //               {
  //                 type: EMenuEntry.ITEM,
  //                 title: 'nav:recruitment.browse-guilds',
  //                 link: '/search?type=guild&recruitment.guild_raids.languages[0][eq]=&recruitment.guild_raids.tags[0][eq]=&recruitment.guild_raids.schedule[0][eq][endTime]=&recruitment.guild_raids.schedule[0][eq][day]=&recruitment.guild_raids.profile.published_at[0][gte]=&sort[recruitment.guild_raids.profile.published_at]=desc'
  //               },
  //               {
  //                 type: EMenuEntry.ITEM,
  //                 title: 'nav:recruitment.browse-players',
  //                 link: '/search?type=character&recruitment.guild_raids.main_character.main_roles[0][eq]=tank&recruitment.guild_raids.main_character.mainspec_ids[0][eq]=&recruitment.guild_raids.main_character.offspec_ids[0][eq]=&recruitment.guild_raids.schedule[0][eq][day]=&recruitment.guild_raids.schedule[0][eq][startTime]=&recruitment.guild_raids.schedule[0][eq][endTime]=&recruitment.guild_raids.profile.published_at[0][gte]=&sort[recruitment.guild_raids.profile.published_at]=desc'
  //               },
  //               { type: EMenuEntry.DIVIDER },
  //               {
  //                 type: EMenuEntry.ITEM,
  //                 title: 'nav:recruitment.about-recruitment',
  //                 className: 'text-raiderio text-bold',
  //                 link: resolveRoutePath(namedRoutes.Recruitment)
  //               }
  //             ]
  //           : [
  //               {
  //                 type: EMenuEntry.ITEM,
  //                 title: 'nav:recruitment.browse-guilds',
  //                 link: '/search?type=guild&&recruitment.guild_raids.languages[0][eq]=&recruitment.guild_raids.tags[0][eq]=&recruitment.guild_raids.schedule[0][eq][endTime]=&recruitment.guild_raids.schedule[0][eq][day]=&recruitment.guild_raids.profile.published_at[0][gte]=&sort[recruitment.guild_raids.profile.published_at]=desc'
  //               },
  //               {
  //                 type: EMenuEntry.ITEM,
  //                 title: 'nav:recruitment.browse-players',
  //                 link: '/search?type=character&recruitment.guild_raids.main_character.main_roles[0][eq]=tank&recruitment.guild_raids.main_character.mainspec_ids[0][eq]=&recruitment.guild_raids.main_character.offspec_ids[0][eq]=&recruitment.guild_raids.schedule[0][eq][day]=&recruitment.guild_raids.schedule[0][eq][startTime]=&recruitment.guild_raids.schedule[0][eq][endTime]=&recruitment.guild_raids.profile.published_at[0][gte]=&sort[recruitment.guild_raids.profile.published_at]=desc'
  //               },
  //               {
  //                 type: EMenuEntry.DIVIDER
  //               },
  //               {
  //                 type: EMenuEntry.ITEM,
  //                 title: 'nav:recruitment.about-recruitment',
  //                 className: 'text-bold text-raiderio',
  //                 link: resolveRoutePath(namedRoutes.Recruitment)
  //               }
  //             ]
  //       }
  //     ]
  //   : [];

  return [
    // ...RAID_MENU,
    // ...RECRUITMENT_MENU,
    {
      type: EMenuEntry.ITEM,
      title: 'Home',
      titleClass: 'text-bold',
      link: resolveRoutePath(namedRoutes.Home)
    },
    {
      type: EMenuEntry.ITEM,
      title: 'nav:main.classic-fresh',
      titleClass: 'text-bold',
      // isNew: true,
      link: resolveRoutePath(namedRoutes.Home),
      children: [
        {
          type: EMenuEntry.ITEM,
          title: 'nav:raids.character-rankings',
          wowIcon: 'ui_promotion_characterboost',
          link: resolveRoutePath(namedRoutes.CharacterRankings, {
            type: 'fresh_highest_item_level',
            region: 'world',
            realm: 'all',
            faction: 'all',
            class: 'all'
          }),
          children: [
            {
              type: EMenuEntry.ITEM,
              title: 'nav:all-classes',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'fresh_highest_item_level',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              })
            },
            ...[...CLASS_DATA]
              .sort((a, b) => a.slug.localeCompare(b.slug))
              .map((cls) => ({
                type: EMenuEntry.ITEM,
                link: resolveRoutePath(namedRoutes.CharacterRankings, {
                  type: 'fresh_highest_item_level',
                  region: 'world',
                  realm: 'all',
                  faction: 'all',
                  class: cls.slug
                }),
                customIconComponent: createElement(ClassIcon, { class: cls.slug }),
                className: `class-color--${cls.slug}`,
                title: `${t(`game:classes.${cls.slug}.name`)}`
              }))
          ]
        },
        { type: EMenuEntry.DIVIDER },
        {
          type: EMenuEntry.ITEM,
          title: 'nav:raids.hardcore-hall-of-fame',
          wowIcon: 'spell_holy_championsgrace',
          link: resolveRoutePath(namedRoutes.CharacterRankings, {
            type: 'fresh_hardcore_level',
            region: 'world',
            realm: 'all',
            faction: 'all',
            class: 'all'
          }),
          children: [
            {
              type: EMenuEntry.ITEM,
              title: 'nav:all-classes',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'fresh_hardcore_level',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              })
            },
            ...[...CLASS_DATA]
              .sort((a, b) => a.slug.localeCompare(b.slug))
              .map((cls) => ({
                type: EMenuEntry.ITEM,
                link: resolveRoutePath(namedRoutes.CharacterRankings, {
                  type: 'fresh_hardcore_level',
                  region: 'world',
                  realm: 'all',
                  faction: 'all',
                  class: cls.slug
                }),
                customIconComponent: createElement(ClassIcon, { class: cls.slug }),
                className: `class-color--${cls.slug}`,
                title: `${t(`game:classes.${cls.slug}.name`)}`
              }))
          ]
        },
        {
          type: EMenuEntry.ITEM,
          title: 'frontpage:section-header-hardcore-graveyard',
          wowIcon: 'achievement_bg_xkills_avgraveyard',
          link: resolveRoutePath(namedRoutes.CharacterRankings, {
            type: 'fresh_highest_ghosted',
            region: 'world',
            realm: 'all',
            faction: 'all',
            class: 'all'
          }),
          children: [
            {
              type: EMenuEntry.ITEM,
              title: 'nav:leaderboards.highest-ghosts',
              wowIcon: 'misc_arrowlup',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'fresh_highest_ghosted',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              })
            },
            {
              type: EMenuEntry.ITEM,
              title: 'nav:leaderboards.recently-ghosted',
              wowIcon: 'spell_mage_altertime',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'fresh_recent_ghosted',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              })
            }
          ]
        },
        {
          type: EMenuEntry.ITEM,
          title: 'nav:leaderboards.makgora-champions',
          wowIcon: 'warrior_skullbanner',
          link: resolveRoutePath(namedRoutes.CharacterRankings, {
            type: 'fresh_makgora_kills',
            region: 'world',
            realm: 'all',
            faction: 'all',
            class: 'all'
          }),
          children: [
            {
              type: EMenuEntry.ITEM,
              title: t('nav:leaderboards.faction-makgora-champions', { faction: t('common:factions.alliance.name') }),
              wowIcon: 'ui_allianceicon',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'fresh_makgora_kills',
                region: 'world',
                realm: 'all',
                faction: 'alliance',
                class: 'all'
              })
            },
            {
              type: EMenuEntry.ITEM,
              title: t('nav:leaderboards.faction-makgora-champions', { faction: t('common:factions.horde.name') }),
              wowIcon: 'ui_hordeicon',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'fresh_makgora_kills',
                region: 'world',
                realm: 'all',
                faction: 'horde',
                class: 'all'
              })
            }
          ]
        },
        { type: EMenuEntry.DIVIDER },

        {
          type: EMenuEntry.ITEM,
          title: 'nav:raids.self-found-hardcore-hall-of-fame',
          wowIcon: 'ui_selffound',
          children: [
            {
              type: EMenuEntry.ITEM,
              title: 'nav:raids.character-rankings',
              wowIcon: 'ui_promotion_characterboost',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'fresh_hardcore_level_self_found',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              }),
              children: [
                {
                  type: EMenuEntry.ITEM,
                  title: 'nav:all-classes',
                  link: resolveRoutePath(namedRoutes.CharacterRankings, {
                    type: 'fresh_hardcore_level_self_found',
                    region: 'world',
                    realm: 'all',
                    faction: 'all',
                    class: 'all'
                  })
                },
                ...[...CLASS_DATA]
                  .sort((a, b) => a.slug.localeCompare(b.slug))
                  .map((cls) => ({
                    type: EMenuEntry.ITEM,
                    link: resolveRoutePath(namedRoutes.CharacterRankings, {
                      type: 'fresh_hardcore_level_self_found',
                      region: 'world',
                      realm: 'all',
                      faction: 'all',
                      class: cls.slug
                    }),
                    customIconComponent: createElement(ClassIcon, { class: cls.slug }),
                    className: `class-color--${cls.slug}`,
                    title: `${t(`game:classes.${cls.slug}.name`)}`
                  }))
              ]
            },
            {
              type: EMenuEntry.ITEM,
              title: 'frontpage:section-header-hardcore-graveyard-self-found',
              wowIcon: 'achievement_bg_xkills_avgraveyard',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'fresh_highest_ghosted_self_found',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              }),
              children: [
                {
                  type: EMenuEntry.ITEM,
                  title: 'nav:leaderboards.highest-ghosts',
                  wowIcon: 'misc_arrowlup',
                  link: resolveRoutePath(namedRoutes.CharacterRankings, {
                    type: 'fresh_highest_ghosted_self_found',
                    region: 'world',
                    realm: 'all',
                    faction: 'all',
                    class: 'all'
                  })
                },
                {
                  type: EMenuEntry.ITEM,
                  title: 'nav:leaderboards.recently-ghosted',
                  wowIcon: 'spell_mage_altertime',
                  link: resolveRoutePath(namedRoutes.CharacterRankings, {
                    type: 'fresh_recent_ghosted_self_found',
                    region: 'world',
                    realm: 'all',
                    faction: 'all',
                    class: 'all'
                  })
                }
              ]
            },
            {
              type: EMenuEntry.ITEM,
              title: 'nav:leaderboards.makgora-champions-self-found',
              wowIcon: 'warrior_skullbanner',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'fresh_makgora_kills_self_found',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              }),
              children: [
                {
                  type: EMenuEntry.ITEM,
                  title: t('nav:leaderboards.faction-makgora-champions', {
                    faction: t('common:factions.alliance.name')
                  }),
                  wowIcon: 'ui_allianceicon',
                  link: resolveRoutePath(namedRoutes.CharacterRankings, {
                    type: 'fresh_makgora_kills_self_found',
                    region: 'world',
                    realm: 'all',
                    faction: 'alliance',
                    class: 'all'
                  })
                },
                {
                  type: EMenuEntry.ITEM,
                  title: t('nav:leaderboards.faction-makgora-champions', { faction: t('common:factions.horde.name') }),
                  wowIcon: 'ui_hordeicon',
                  link: resolveRoutePath(namedRoutes.CharacterRankings, {
                    type: 'fresh_makgora_kills_self_found',
                    region: 'world',
                    realm: 'all',
                    faction: 'horde',
                    class: 'all'
                  })
                }
              ]
            }
          ]
        }
      ]
    },

    {
      type: EMenuEntry.ITEM,
      title: 'nav:main.season-of-discovery',
      titleClass: 'text-bold',
      link: resolveRoutePath(namedRoutes.CharacterRankings, {
        type: 'season_of_discovery',
        region: 'world',
        realm: 'all',
        faction: 'all',
        class: 'all'
      }),
      children: [
        {
          type: EMenuEntry.ITEM,
          title: 'nav:raids.character-rankings',
          wowIcon: 'inv_misc_book_11',
          link: resolveRoutePath(namedRoutes.CharacterRankings, {
            type: 'season_of_discovery',
            region: 'world',
            realm: 'all',
            faction: 'all',
            class: 'all'
          }),
          children: [
            {
              type: EMenuEntry.ITEM,
              title: 'nav:all-classes',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'season_of_discovery',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              })
            },
            ...[...CLASS_DATA]
              .sort((a, b) => a.slug.localeCompare(b.slug))
              .map((cls) => ({
                type: EMenuEntry.ITEM,
                link: resolveRoutePath(namedRoutes.CharacterRankings, {
                  type: 'season_of_discovery',
                  region: 'world',
                  realm: 'all',
                  faction: 'all',
                  class: cls.slug
                }),
                customIconComponent: createElement(ClassIcon, { class: cls.slug }),
                className: `class-color--${cls.slug}`,
                title: `${t(`game:classes.${cls.slug}.name`)}`
              }))
          ]
        }
      ]
    },

    {
      type: EMenuEntry.ITEM,
      title: 'Hardcore', //'nav:leaderboards.leaderboards',
      titleClass: 'text-bold',
      link: resolveRoutePath(namedRoutes.CharacterRankings, {
        type: 'hardcore_level',
        region: 'world',
        realm: 'all',
        faction: 'all',
        class: 'all'
      }),
      children: [
        {
          type: EMenuEntry.ITEM,
          title: 'nav:raids.hardcore-hall-of-fame',
          wowIcon: 'spell_holy_championsgrace',
          link: resolveRoutePath(namedRoutes.CharacterRankings, {
            type: 'hardcore_level',
            region: 'world',
            realm: 'all',
            faction: 'all',
            class: 'all'
          }),
          children: [
            {
              type: EMenuEntry.ITEM,
              title: 'nav:all-classes',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'hardcore_level',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              })
            },
            ...[...CLASS_DATA]
              .sort((a, b) => a.slug.localeCompare(b.slug))
              .map((cls) => ({
                type: EMenuEntry.ITEM,
                link: resolveRoutePath(namedRoutes.CharacterRankings, {
                  type: 'hardcore_level',
                  region: 'world',
                  realm: 'all',
                  faction: 'all',
                  class: cls.slug
                }),
                customIconComponent: createElement(ClassIcon, { class: cls.slug }),
                className: `class-color--${cls.slug}`,
                title: `${t(`game:classes.${cls.slug}.name`)}`
              }))
          ]
        },
        {
          type: EMenuEntry.ITEM,
          title: 'frontpage:section-header-hardcore-graveyard',
          wowIcon: 'achievement_bg_xkills_avgraveyard',
          link: resolveRoutePath(namedRoutes.CharacterRankings, {
            type: 'highest_ghosted',
            region: 'world',
            realm: 'all',
            faction: 'all',
            class: 'all'
          }),
          children: [
            {
              type: EMenuEntry.ITEM,
              title: 'nav:leaderboards.highest-ghosts',
              wowIcon: 'misc_arrowlup',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'highest_ghosted',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              })
            },
            {
              type: EMenuEntry.ITEM,
              title: 'nav:leaderboards.recently-ghosted',
              wowIcon: 'spell_mage_altertime',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'recent_ghosted',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              })
            }
          ]
        },
        {
          type: EMenuEntry.ITEM,
          title: 'nav:leaderboards.makgora-champions',
          wowIcon: 'warrior_skullbanner',
          link: resolveRoutePath(namedRoutes.CharacterRankings, {
            type: 'makgora_kills',
            region: 'world',
            realm: 'all',
            faction: 'all',
            class: 'all'
          }),
          children: [
            {
              type: EMenuEntry.ITEM,
              title: t('nav:leaderboards.faction-makgora-champions', { faction: t('common:factions.alliance.name') }),
              wowIcon: 'ui_allianceicon',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'makgora_kills',
                region: 'world',
                realm: 'all',
                faction: 'alliance',
                class: 'all'
              })
            },
            {
              type: EMenuEntry.ITEM,
              title: t('nav:leaderboards.faction-makgora-champions', { faction: t('common:factions.horde.name') }),
              wowIcon: 'ui_hordeicon',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'makgora_kills',
                region: 'world',
                realm: 'all',
                faction: 'horde',
                class: 'all'
              })
            }
          ]
        },

        { type: EMenuEntry.DIVIDER },
        {
          type: EMenuEntry.ITEM,
          title: 'nav:raids.self-found-hardcore-hall-of-fame',
          wowIcon: 'ui_selffound',
          children: [
            {
              type: EMenuEntry.ITEM,
              title: 'nav:raids.self-found-hardcore-hall-of-fame',
              wowIcon: 'ui_selffound',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'hardcore_level_self_found',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              }),
              children: [
                {
                  type: EMenuEntry.ITEM,
                  title: 'nav:all-classes',
                  link: resolveRoutePath(namedRoutes.CharacterRankings, {
                    type: 'hardcore_level_self_found',
                    region: 'world',
                    realm: 'all',
                    faction: 'all',
                    class: 'all'
                  })
                },
                ...[...CLASS_DATA]
                  .sort((a, b) => a.slug.localeCompare(b.slug))
                  .map((cls) => ({
                    type: EMenuEntry.ITEM,
                    link: resolveRoutePath(namedRoutes.CharacterRankings, {
                      type: 'hardcore_level_self_found',
                      region: 'world',
                      realm: 'all',
                      faction: 'all',
                      class: cls.slug
                    }),
                    customIconComponent: createElement(ClassIcon, { class: cls.slug }),
                    className: `class-color--${cls.slug}`,
                    title: `${t(`game:classes.${cls.slug}.name`)}`
                  }))
              ]
            },
            {
              type: EMenuEntry.ITEM,
              title: 'frontpage:section-header-hardcore-graveyard-self-found',
              wowIcon: 'achievement_bg_xkills_avgraveyard',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'highest_ghosted_self_found',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              }),
              children: [
                {
                  type: EMenuEntry.ITEM,
                  title: 'nav:leaderboards.highest-ghosts',
                  wowIcon: 'misc_arrowlup',
                  link: resolveRoutePath(namedRoutes.CharacterRankings, {
                    type: 'highest_ghosted_self_found',
                    region: 'world',
                    realm: 'all',
                    faction: 'all',
                    class: 'all'
                  })
                },
                {
                  type: EMenuEntry.ITEM,
                  title: 'nav:leaderboards.recently-ghosted',
                  wowIcon: 'spell_mage_altertime',
                  link: resolveRoutePath(namedRoutes.CharacterRankings, {
                    type: 'recent_ghosted_self_found',
                    region: 'world',
                    realm: 'all',
                    faction: 'all',
                    class: 'all'
                  })
                }
              ]
            },
            {
              type: EMenuEntry.ITEM,
              title: 'nav:leaderboards.makgora-champions-self-found',
              wowIcon: 'warrior_skullbanner',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'makgora_kills_self_found',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              }),
              children: [
                {
                  type: EMenuEntry.ITEM,
                  title: t('nav:leaderboards.faction-makgora-champions', {
                    faction: t('common:factions.alliance.name')
                  }),
                  wowIcon: 'ui_allianceicon',
                  link: resolveRoutePath(namedRoutes.CharacterRankings, {
                    type: 'makgora_kills_self_found',
                    region: 'world',
                    realm: 'all',
                    faction: 'alliance',
                    class: 'all'
                  })
                },
                {
                  type: EMenuEntry.ITEM,
                  title: t('nav:leaderboards.faction-makgora-champions', { faction: t('common:factions.horde.name') }),
                  wowIcon: 'ui_hordeicon',
                  link: resolveRoutePath(namedRoutes.CharacterRankings, {
                    type: 'makgora_kills_self_found',
                    region: 'world',
                    realm: 'all',
                    faction: 'horde',
                    class: 'all'
                  })
                }
              ]
            }
          ]
        }
      ]
    },

    {
      type: EMenuEntry.ITEM,
      title: 'nav:main.realms',
      titleClass: 'text-bold',
      link: '/realms',
      children: getRealmsMenuItems(props)
    },

    {
      type: EMenuEntry.ITEM,
      title: 'nav:main.events',
      titleClass: 'text-bold',
      isLive: false,
      children: [
        {
          type: EMenuEntry.ITEM,
          title: 'Only Fangs • Season 2',
          titleClass: 'text-bold color-raiderio',
          wowIcon: 'inv_misc_monsterfang_02',
          isLive: false,
          link: 'https://raider.io/events/onlyfangs-season-2-hardcore',
          children: [
            {
              type: EMenuEntry.ITEM,
              title: 'Event Info',
              link: 'https://raider.io/events/onlyfangs-season-2-hardcore/info'
            },
            {
              type: EMenuEntry.ITEM,
              title: 'Guild Roster',
              link: '/guilds/us/doomhowl/OnlyFangs'
            }
          ]
        },
        {
          type: EMenuEntry.DIVIDER
        },
        {
          type: EMenuEntry.ITEM,
          title: 'nav:events.otk-hardcore-makgora.title',
          wowIcon: 'warrior_skullbanner',
          children: [
            {
              type: EMenuEntry.ITEM,
              title: 'nav:events.otk-hardcore-makgora.leaderboard',
              link: resolveRoutePath(namedRoutes.CharacterRankings, {
                type: 'otk-hardcore-makgora-level',
                region: 'world',
                realm: 'all',
                faction: 'all',
                class: 'all'
              }),
              children: [...CLASS_DATA]
                .sort((a, b) => a.slug.localeCompare(b.slug))
                .map((cls) => ({
                  type: EMenuEntry.ITEM,
                  link: resolveRoutePath(namedRoutes.CharacterRankings, {
                    type: 'otk-hardcore-makgora-level',
                    region: 'world',
                    realm: 'all',
                    faction: 'all',
                    class: cls.slug
                  }),
                  customIconComponent: createElement(ClassIcon, { class: cls.slug }),
                  className: `class-color--${cls.slug}`,
                  title: `${t(`game:classes.${cls.slug}.name`)}`
                }))
            },
            {
              type: EMenuEntry.DIVIDER
            },
            {
              type: EMenuEntry.ITEM,
              title: 'nav:events.otk-hardcore-makgora.registration',
              link: resolveRoutePath(namedRoutes.OTKMakgoraRegistrationPage)
            },
            {
              type: EMenuEntry.DIVIDER
            },
            {
              type: EMenuEntry.ITEM,
              title: 'nav:events.otk-hardcore-makgora.announcement',
              link: 'https://raider.io/news/561-introducing-the-otk-hardcore-makgora'
            }
          ]
        }
      ]
    },

    // {
    //   type: EMenuEntry.ITEM,
    //   title: 'nav:main.guides',
    //   titleClass: 'text-bold',
    //   children: GUIDES_MENU_ITEMS
    // },
    {
      type: EMenuEntry.ITEM,
      title: 'nav:main.extras',
      titleClass: 'text-bold',
      children: getExtrasMenus(props)
    }
    // {
    //   type: EMenuEntry.ITEM,
    //   link: '/addon',
    //   title: 'nav:main.addon',
    //   titleClass: 'text-bold',
    //   postIconClass: 'fas fa-download slds-m-left--x-small slds-text-body--small text-raiderio'
    // }
  ] as TMenuEntry[];
}
